export default "__VITE_ASSET__DIRfBAac__"